"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.initialState = void 0;
const react_1 = require("react");
exports.initialState = {
    isLoading: true,
    isSignout: true,
    permissions: [],
};
const createReducer = ({ onError }) => (prevState, action) => {
    switch (action.type) {
        case 'BOOTSTRAP': {
            const { isSignout, permissions } = action.payload;
            return {
                ...prevState,
                isLoading: false,
                isSignout,
                permissions,
            };
        }
        case 'ERROR': {
            const error = action.payload.error;
            if (onError)
                onError(error);
            return {
                ...prevState,
            };
        }
        case 'SIGN_IN': {
            const { permissions } = action.payload;
            return {
                ...prevState,
                isSignout: false,
                permissions,
            };
        }
        case 'SIGN_OUT': {
            return {
                ...prevState,
                isSignout: true,
                permissions: [],
            };
        }
    }
};
function useAuthReducer(options) {
    const reducer = react_1.useMemo(() => createReducer(options), [options]);
    return react_1.useReducer(reducer, exports.initialState);
}
exports.default = useAuthReducer;
